import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-canvas py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-124" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-125" data-mp="1dxt8h2q7n8j9">
        <div className="text-center" data-id="element-126" data-mp="1dunlbt156gq6">
          <span className="inline-flex items-center gap-2 rounded-md bg-leaf-600 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-white" data-id="element-127" data-mp="2bkierory47ax">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="26jbahzp0hq90" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-129" data-mp="1wn87ysq8zplj">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-130" data-mp="q4jgjic7waxl">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-navy-100 bg-white shadow-sm" data-id="element-131" data-mp="1ivryulz6j34s" data-mpi={index}>
                <div className="flex items-center gap-4 bg-navy-900 px-6 py-5" data-id="element-132" data-mp="14vh9xohfjym9">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-leaf-500 text-white" data-id="element-133" data-mp="14xaff0gb4cso">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-134" data-mp="v5efdjunuclt" />
                  </span>
                  <div data-id="element-135" data-mp="h5v6upxxsz8z">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-sun-400" data-id="element-136" data-mp="h5mtyy1tdtxs">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-137" data-mp="2nu5dyeuoad39">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-138" data-mp="2j2ne5u4dyijv">
                  <p className="font-semibold text-leaf-700" data-id="element-139" data-mp="2e42jea7wkr2t">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-navy-700" data-id="element-140" data-mp="295988og39c5t">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-navy-700" data-id="element-141" data-mp="36s84wz6s6k3p">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-142" data-mp="31upypgk5eize">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-navy-900" data-id="element-143" data-mp="2st8k62me2pct">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf-600" aria-hidden="true" data-id="element-144" data-mp="1lfolrvkq7wrs" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-leaf-500 bg-leaf-50 p-4 text-sm leading-relaxed text-navy-900" data-id="element-145" data-mp="3t1opcn2yszjf">
                    <b className="font-extrabold text-leaf-700" data-id="element-146" data-mp="ynsi4vxk8ln">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-navy-900 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-147" data-mp="aoqkq2v89iix">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-navy-200" data-id="element-148" data-mp="kl3nrrcnx8qc">Colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-149" data-mp="omypgwyi9o4n">
            {totalVolumes} tomos premium <span className="mx-2 text-leaf-400" data-id="element-150" data-mp="tl085gs0rlfl">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}